import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ru from "./assets/locales/ru.json";
import uz from "./assets/locales/uz.json";

const resources = {
  uz,
  ru,
};

i18n.use(initReactI18next).init({
  resources,
  lng: "uz",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
